/**
 * CSG Operations walkthrough.
 * @module features/walkthrough/tours/csgTour
 */

import { t, tourMeta } from '../i18n/walkthroughI18n';
import { navItemPath, navStep } from './navTourHelpers';

const meta = tourMeta('csg-operations');

/** @type {import('../walkthroughTypes').WalkthroughTourDef} */
export const CSG_TOUR = {
  id: 'csg-operations',
  title: meta.title,
  description: meta.description,
  roles: ['csg'],
  prerequisiteRoute: navItemPath('csg-project-hours') ?? '/csg/project-hours',
  priority: 20,
  version: 2,
  visible: (_user, ctx) => ctx.showCsgNav,
  steps: [
    {
      id: 'csg-access-scope',
      title: t('walkthrough.csg.accessScope.title'),
      body: t('walkthrough.csg.accessScope.body'),
      placement: 'modal',
    },
    navStep('csg-project-hours', {
      title: t('walkthrough.csg.projectHours.title'),
      body: t('walkthrough.csg.projectHours.body'),
    }),
    navStep('csg-employee-hours', {
      title: t('walkthrough.csg.employeeHours.title'),
      body: t('walkthrough.csg.employeeHours.body'),
    }),
    navStep('csg-download-timesheet', {
      title: t('walkthrough.csg.download.title'),
      body: t('walkthrough.csg.download.body'),
    }),
  ],
};
